import { DisplayInputValue } from '@reapitform/dashboard-ui'
import { LoadingSkeleton } from '@reapitform/common-ui'
import React, { FC } from 'react'

const PersonalInformationDisplayViewLoading: FC = () => {
  return (
    <>
      <DisplayInputValue title="Reply-to name">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
      <DisplayInputValue title="Reply-to email address">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
      <DisplayInputValue title="Mobile">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
      <DisplayInputValue title="Digital Signature">
        <LoadingSkeleton height="1.25rem" />
      </DisplayInputValue>
    </>
  )
}

export default PersonalInformationDisplayViewLoading
